<template>
    <VForm
        v-slot="validation"
        @submit="onSubmit">
        <div class="grid sm:grid-cols-1 gap-6">
            <div>
                <label class="block text-gray-900 dark:text-gray-300 text-sm font-medium leading-6">
                    Maßnahmendokumente
                </label>
                <BaseDropzone
                    :model-value="documents"
                    accept="application/pdf"
                    visibility="local"
                    multiple
                    folder="process/documents"
                    upload-icon="bx:bxs-file-pdf"
                    upload-icon-class="text-gray-600"
                    dropzone-class="py-3 pl-4 pr-5"
                    input-id="file-upload-process"
                    @update:model-value="files => documents = files" />
            </div>
        </div>
        <BaseSubmitButtons
            :submit-label="$t('processes.addDocuments.addDocuments')"
            :loading="loading"
            :validation="validation"
            @cancel="emits('reload')" />
    </VForm>
</template>

<script setup>
import {useNuxtApp} from "nuxt/app"
import {$lara} from '@/utils/$larafetch'
import {useNotification} from "~/composables/useNotification"

const props = defineProps({
    process: {
        type: Object,
        required: true
    }
})

const emits = defineEmits(['reload'])

const {$apiRoute} = useNuxtApp()
const notification = useNotification()
const app = useNuxtApp()
const {t: $t} = useI18n()

const loading = ref(false)
const documents = ref([])

function onSubmit() {
    loading.value = true

    $lara.put(
        $apiRoute('spa.processes.processDocuments.store'), {
            body: {
                process_id: props.process.id,
                documents: documents.value
            }
        }
    ).then(() => {
        notification.success($t('processes.addDocuments.addDocumentsSuccess'))

        emits('reload')
    }).catch((error) => {
        if (error && error.response && error.response.status === 422) {
            notification.error(app.$i18n.t('invalidRequestData'))
        } else if (error && error.response && error.response.status === 404) {
            notification.error(app.$i18n.t('modelDoesNotExist'))
        } else {
            if (error && error.response?._data.message) {
                notification.error(app.$i18n.t('generalRequestError') + '\n' + error.response._data.message)
            } else if ( error && error.response?._data) {
                notification.error(app.$i18n.t('generalRequestError') + '\n' + error.response._data)
            } else {
                notification.error(app.$i18n.t('generalRequestError'))
            }
        }
    }).finally(() => {
        loading.value = false
    })
}
</script>

<style scoped>

</style>